import type { ReactElement } from 'react'

import { CheckmarkOutlineIcon } from '@twisto/icons'

import { typographyVariant } from '../typography'

import * as styles from './password-strength.styles'

type Props<T extends Record<string, unknown> = Record<string, unknown>> = {
  rulesMap: { [P in keyof T]: boolean }
  rulesNodes: { [P in keyof T]: ReactElement | string }
}

export const PasswordStrengthRuleList = <T extends Record<string, unknown>>({
  rulesMap,
  rulesNodes,
}: Props<T>) => (
  <ul css={styles.root} data-testid="password-strength-rule-list">
    {Object.keys(rulesNodes).map((nodeKey) => {
      const isChecked = rulesMap[nodeKey as keyof T]
      const check = (
        <CheckmarkOutlineIcon
          aria-label={isChecked ? 'password-matched' : 'password-not-matched'}
          color={isChecked ? 'primary' : 'inherit'}
          height="100%"
          width="100%"
        />
      )

      const node = rulesNodes[nodeKey as keyof T]

      return (
        <li key={nodeKey} aria-label={nodeKey} css={styles.listItem}>
          <div css={styles.listItemIcon}>{check}</div>
          <div
            css={[
              styles.listItemText,
              typographyVariant.b3,
              isChecked && styles.checkedListItemText,
            ]}
          >
            {node}
          </div>
        </li>
      )
    })}
  </ul>
)
